import { restauth } from "../index";
import axios from "axios";
export const getAction = (service, id, reducer) => {
  console.log("Getting service " + service);
  var url;
  var message;
  if (id === undefined) {
    url = "/" + service;
  } else {
    url = "/" + service + "/" + id;
  }
  console.log("Sending request to " + url);
  if (reducer === undefined) {
    message = "GOT " + service;
  } else {
    message = "Got " + service + " For " + reducer;
  }
  return {
    type: message,
    payload: restauth.get(url)
  };
};
export const queryaction = (service, ...args) => {
  console.log("Getting service " + service);
  var queryurl = "/" + service;
  var querymessage = "Query for " + service;
  for (let arg of args) {
    queryurl.concat("?" + arg.param + "=" + arg.value + "&");
  }

  return {
    type: querymessage,
    payload: restauth.get(queryurl)
  };
};
export const simplequery = (service, param, value) => {
  var queryurl = "/" + service + "?" + param + "=" + value;
  var querymessage = "Query for " + service;
  console.log(queryurl);
  return {
    type: querymessage,
    payload: restauth.get(queryurl)
  };
};



// WEBPACK FOOTER //
// ./src/actions/get-action.js